module.exports = __webpack_public_path__ + "static/tools-305a87e043851b20190ad5665e75a377.svg";